import { httpCatalog } from "../helper/http-common";

class CatalogColorStoneDataService {
    GetColorStones(inputData, type) {
        return httpCatalog.post("/ColorStone/GetColorStones", inputData);
    }
     GetAllDropdownData(inputData) {
    return httpCatalog.post("/ColorStone/GetAllColorStoneDropdownData", inputData);
  }
  GetDynamicData(inputData) {
    return httpCatalog.post("/ColorStone/GetDynamicDataColorStone", inputData);
  }
   UploadColorStoneDataFile(inputData) {
    return httpCatalog.post("/ColorStone/UploadColorStoneDataFile", inputData);
  }
  UploadColorStoneImageFiles(inputData) {
    return httpCatalog.post("/ColorStone/UploadColorStoneImageFiles", inputData);
  }
  SendFriendemail(inputData) {
    return httpCatalog.post("/ColorStone/SendFriendemailColorStone", inputData);
  }
  GetDealersForColorStoneCatalogList(inputData) {
    return httpCatalog.post(
      "/ColorStone/GetDealersForColorStoneCatalogList",
      inputData
    );
  }
  GetCertificatesForColorStoneCatalogList(inputData) {
    return httpCatalog.post(
      "/ColorStone/GetCertificatesForColorStoneCatalogList",
      inputData
    );
  }
  GetAllMinedColorStoneDropDownList(inputData) {
    return httpCatalog.post("/ColorStone/GetAllMinedColorStoneDropDownList", inputData);
  }
  SendInviteMailForColorStones(inputData) {
    return httpCatalog.post("/ColorStone/SendInviteMailForColorStones", inputData);
  }
  DeleteColorStoneByIds(inputData) {
    return httpCatalog.post("/ColorStone/DeleteColorStoneByIds", inputData);
  }
  SendMsg(inputData) {
    return httpCatalog.post("/ColorStone/SendMsgColorStone", inputData);
  }
  CreateCSVColorStones(inputData) {
    return httpCatalog.post("/ColorStone/CreateCSVColorStones", inputData, {
      responseType: "arraybuffer",
    });
  }
  GetColorStoneMappingDropdownDetails(inputData) {
    return httpCatalog.post(
      "/Mapping/GetColorStoneMappingDropdownDetails",
      inputData
    );
  }
   SaveColorStone(inputData) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return httpCatalog.post("/ColorStone/SaveColorStone", inputData, {
      headers,
    });
  }
  GetColorStoneMappAttributesList(inputData) {
    return httpCatalog.post("/Mapping/GetColorStoneMappAttributesList", inputData);
  }
  GetColorStoneNotMappAttributesList(inputData) {
      return httpCatalog.post(
        "/Mapping/GetColorStoneNotMappAttributesList",
        inputData
      );
    }
    GetColorStoneColumnsOfDealerUpload(inputData) {
    return httpCatalog.post(
      "/Mapping/GetColorStoneColumnsOfDealerUpload",
      inputData
    );
  }
   UpdateColorStoneColumnsOfDealerUpload(inputData) {
    return httpCatalog.post(
      "/Mapping/UpdateColorStoneColumnsOfDealerUpload",
      inputData
    );
  }
  GetColorStoneMappNotMappCount(inputData) {
    return httpCatalog.post("/Mapping/GetColorStoneMappNotMappCount", inputData);
  }
   GetColorStoneMappingList(inputData) {
    return httpCatalog.post("/Mapping/GetColorStoneMappingList", inputData);
  }
  MappColorStoneDealerColumns(inputData) {
    return httpCatalog.post("/Mapping/MappColorStoneDealerColumns", inputData);
  }
   RemoveMappColorStoneDealerColumns(inputData) {
    return httpCatalog.post(
      "/Mapping/RemoveMappColorStoneDealerColumns",
      inputData
    );
  }
  DownloadColorStoneAttributesMapFile(inputData) {
    return httpCatalog.post(
      "/Mapping/DownloadColorStoneAttributesMapFile",
      inputData,
      {
        responseType: "arraybuffer",
      }
    );
  }
  ResetColorStoneDataMapping(inputData) {
    return httpCatalog.post("/Mapping/ResetColorStoneDataMapping", inputData);
  }
  UploadColorStoneMappSheet(inputData) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return httpCatalog.post("/Mapping/UploadColorStoneMappSheet", inputData, {
      headers,
    });
  }
   GetColorStoneAttributeDetailsList(inputData) {
    return httpCatalog.post(
      "/Mapping/GetColorStoneAttributeDetailsList",
      inputData
    );
  }
   UploadColorStoneDataFile(inputData) {
    return httpCatalog.post("/ColorStone/UploadColorStoneDataFile", inputData);
  }
  CreateCSVColorStones(inputData) {
    return httpCatalog.post("/ColorStone/CreateCSVColorStones", inputData, {
      responseType: "arraybuffer",
    });
  }
  GetDealersForColorStoneSearch(inputData) {
    return httpCatalog.post("/ColorStone/GetDealersForColorStoneSearch", inputData);
  }
}

export default new CatalogColorStoneDataService();